<ng-container *ngIf="headerTpl">
  <ng-container *ngTemplateOutlet="headerTpl"></ng-container>
</ng-container>

<ng-container *ngTemplateOutlet="mainTpl"></ng-container>
